module.exports = __webpack_public_path__ + "static/img/019 3.740c654e.jpg";